// removed by extract-text-webpack-plugin
module.exports = {"headerContainer":"headerContainer__1lJui","headerText":"headerText__OmUad","otpWrapper":"otpWrapper__1I9OE","subText":"subText__WVvJG","innerSubText":"innerSubText__m9PAT","mobileInputContainer":"mobileInputContainer__1zRC0","inputBox":"inputBox__1zwwv","submitButton":"submitButton__1NrT_","otpSubmitButton":"otpSubmitButton__1mD7n","resendOtpContainer":"resendOtpContainer__7NChj","resendAndTncWrapper":"resendAndTncWrapper__2iOhb"};


//////////////////
// WEBPACK FOOTER
// ./componentsBICRevamp/buyWithInstacredLanding/overlayEligibiltyCheck/otpInput/style.css
// module id = oTzC
// module chunks = 323